"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = require('react');

var PropTypes = require('prop-types');

var _ = require('lodash');

var Tooltip = require('../tooltip');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextLabel = require('../textLabel');

var Button = require('../button');

var ActionsListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ActionsListItem, _React$Component);

  var _super = _createSuper(ActionsListItem);

  function ActionsListItem() {
    var _this;

    _classCallCheck(this, ActionsListItem);

    _this = _super.call(this);

    _this.getTextWidth = function () {
      return "calc(100% - ".concat(!_.isEmpty(_this.props.contentBefore) * 96 + !_.isEmpty(_this.props.contentAfter) * 24, "px)");
    };

    return _this;
  }

  _createClass(ActionsListItem, [{
    key: "getPrimaryAction",
    value: function getPrimaryAction() {
      var PrimaryAction = /*#__PURE__*/React.createElement("div", {
        key: "primaryAction",
        "data-aid": "primary-action",
        className: "list-item-primary-action ".concat(this.props.primaryActionData.symbol && 'symbol-item'),
        onClick: this.props.primaryActionData.onClick
      }, this.props.primaryActionData.symbol ? this.props.primaryActionData.symbol : /*#__PURE__*/React.createElement(Button, {
        className: "btn-md"
      }, this.props.primaryActionData.label));

      if (this.props.primaryActionData.tooltipText) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          content: this.props.primaryActionData.tooltipText
        }, PrimaryAction);
      }

      return PrimaryAction;
    }
  }, {
    key: "getSecondaryAction",
    value: function getSecondaryAction() {
      var SecondaryAction = /*#__PURE__*/React.createElement("div", {
        onClick: this.props.secondaryActionData.onClick,
        "data-aid": "secondary-action-icon",
        className: "secondary-action-icon"
      }, this.props.secondaryActionData.symbol);

      if (this.props.secondaryActionData.tooltipText) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          content: this.props.secondaryActionData.tooltipText
        }, SecondaryAction);
      }

      return SecondaryAction;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "control-actions-list-item ".concat(this.props.className)
      }, this.props.iconData ? /*#__PURE__*/React.createElement("div", {
        key: "iconBefore",
        "data-aid": "icon-before",
        className: "list-item-icon-before ".concat(this.props.iconData.type || '')
      }, this.props.iconData.symbol) : null, /*#__PURE__*/React.createElement("div", {
        className: "list-item-text",
        style: {
          width: this.getTextWidth()
        }
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "list-item-label",
        type: "T02",
        value: this.props.label,
        shouldTranslate: this.props.shouldTranslate,
        automationId: "text-label"
      })), this.props.primaryActionData && this.getPrimaryAction(), this.props.secondaryActionData && this.getSecondaryAction());
    }
  }]);

  return ActionsListItem;
}(React.Component);

ActionsListItem.displayName = displayNames.ACTIONS_LIST_ITEM;
ActionsListItem.propTypes = {
  /** Primary Action */
  primaryActionData: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    symbol: PropTypes.element,
    tooltipText: PropTypes.string
  }).isRequired,

  /** The main title for the item */
  label: PropTypes.string.isRequired,

  /** Secondary Action */
  secondaryActionData: PropTypes.shape({
    onClick: PropTypes.func,
    symbol: PropTypes.element,
    tooltipText: PropTypes.string
  }),

  /** Icon Data **/
  iconData: PropTypes.shape({
    symbol: PropTypes.element,
    type: PropTypes.string
  }),

  /** Class Name **/
  className: PropTypes.string
};
module.exports = compose(ActionsListItem);